import { redirect } from 'react-router-dom';

import { getWalmartAuthorizationParams } from 'hooks/router';
import { getReturnUrlFromRequestLoader } from 'utils/common/route';

export const waitingLoader = async ({ request }) => {
  const returnUrl = getReturnUrlFromRequestLoader(request) || '/';

  const { isWalmartAuthorize, walmartSearchQuery } =
    getWalmartAuthorizationParams(request);

  if (isWalmartAuthorize) {
    const redirectUrl = `/eula${walmartSearchQuery}`;
    throw redirect(redirectUrl);
  }

  const redirectUrl = `/eula?returnUrl=${encodeURIComponent(returnUrl)}`;
  throw redirect(redirectUrl);
};
